import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { X } from 'lucide-react';
import './SidebarOverlay.css';

const SidebarOverlay = ({ isOpen, onClose, title, children, width = '480px' }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="sidebar-overlay" onClick={onClose}>
      <div
        className="sidebar-overlay__panel"
        style={{ width }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="sidebar-overlay__header">
          <h3 className="sidebar-overlay__title">{title}</h3>
          <button className="sidebar-overlay__close" onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        {/* Body */}
        <div className="sidebar-overlay__body">{children}</div>
      </div>
    </div>,
    document.body
  );
};

export default SidebarOverlay;